import Contents from "./Contents";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import { closeModal } from "../../features/globalModalSlice";

const SidebarModal = () => {
  const { isOpen } = useSelector((state: RootState) => state.globalModal);
  const dispatch = useDispatch();

  return (
    <div
      className={`w-full h-full absolute top-0 left-0 transition-all ease-in-out bg-none ${
        isOpen ? "z-20" : "-z-10 duration-500"
      }`}
    >
      <div
        onClick={() => dispatch(closeModal())}
        className={`absolute top-0 left-0 w-full h-full bg-slate-900 opacity-50 transition-all ease-out ${
          isOpen ? "block" : "hidden"
        }`}
      ></div>
      <Contents />
    </div>
  );
};

export default SidebarModal;
